import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCampaign = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.9988 15.0012L6.99792 14.9992C4.788 14.9992 2.99625 13.2065 2.99625 10.9955V9.99813C2.99625 7.78721 4.788 5.99547 6.99892 5.99547H13.9998L17.8735 3.34836C19.202 2.44099 21.0038 3.39238 21.0038 5.00105V15.9976C21.0038 17.6063 19.201 18.5577 17.8735 17.6493L13.9988 15.0012Z",
			stroke: "#111827",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0008 5.99744V15.0012",
			stroke: "#111827",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.99751 15.0012L7.52714 18.8608C7.80026 19.5511 8.46253 20.0033 9.19784 20.0033V20.0033C10.4694 20.0033 11.3397 18.7088 10.8705 17.5153L9.88112 15.0012",
			stroke: "#111827",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgCampaign);
export default ForwardRef;
